<template>
  <AssetDrawerValuesHolders ref="holdersRef" v-model:selected="holders" :assets />
  <AssetDrawerValuesChart ref="chartRef" :assets :holders />
</template>

<script setup lang="ts">
import { computed, ref, useTemplateRef } from 'vue'

import { AssetClass } from '..'

import AssetDrawerValuesChart from './AssetDrawerValuesChart.vue'
import AssetDrawerValuesHolders from './AssetDrawerValuesHolders.vue'

type Props = {
  instance: AssetClass
}

const props = defineProps<Props>()

defineOptions({ inheritAttrs: false })

defineExpose({
  refresh: () => {
    holdersRef.value?.refresh()
    chartRef.value?.refresh()
  },
})

const holdersRef = useTemplateRef('holdersRef')
const chartRef = useTemplateRef('chartRef')

const holders = ref<string[]>([])

const assets = computed(() => [props.instance.id])
</script>
